import { useEffect } from "react";
import { filterQueriesAreLoading } from "@/reactiveVars/global";

const inProgressQueries = new Set<string>();

/**
 * Wrap around a query that is filterable by filter sidebar to connect
 * it to the sidebar loading indicator.
 */
export const useFilterSidebarQuery = <T extends { loading: boolean }>(
  qr: T,
  id: string,
): T => {
  useEffect(() => {
    if (qr.loading) {
      inProgressQueries.add(id);
      if (inProgressQueries.size > 0) {
        filterQueriesAreLoading(true);
      }
    } else {
      inProgressQueries.delete(id);
      if (inProgressQueries.size === 0) {
        filterQueriesAreLoading(false);
      }
    }
  }, [qr.loading, id]);
  return qr;
};
